import { useState } from "react";

export default function PincodeFinder() {
  const [pin, setPin] = useState("");
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const getLocation = async () => {
    if (!/^\d{6}$/.test(pin)) {
      setError("Please enter a valid 6-digit PIN code.");
      setData(null);
      return;
    }

    setLoading(true);
    setError("");
    setData(null);

    try {
      const response = await fetch(
        `https://api.postalpincode.in/pincode/${pin}`,
      );
      const result = await response.json();
      //   console.log("result: ", result);

      if (result[0].Status === "Success" && result[0].PostOffice?.length > 0) {
        setData(result[0].PostOffice[0]);
      } else {
        setError("PIN code not found.");
      }
    } catch (err) {
      setError("Failed to fetch data.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        maxWidth: "400px",
        margin: "40px auto",
        padding: "20px",
        border: "1px solid #ddd",
        borderRadius: "10px",
        fontFamily: "Arial",
      }}
    >
      <h2>PIN Code Finder</h2>

      <input
        type="text"
        value={pin}
        maxLength={6}
        placeholder="Enter PIN Code"
        onChange={(e) => setPin(e.target.value)}
        style={{
          width: "100%",
          padding: "10px",
          marginBottom: "10px",
          boxSizing: "border-box",
        }}
      />

      <button
        onClick={getLocation}
        style={{
          width: "100%",
          padding: "10px",
          background: "#007bff",
          color: "#fff",
          border: "none",
          cursor: "pointer",
          borderRadius: "5px",
        }}
      >
        Search
      </button>

      {loading && <p>Loading...</p>}

      {error && <p style={{ color: "red" }}>{error}</p>}

      {data && (
        <div style={{ marginTop: "20px" }}>
          <p>
            <strong>City:</strong> {data.District}
          </p>
          <p>
            <strong>State:</strong> {data.State}
          </p>
          <p>
            <strong>Area:</strong> {data.Name}
          </p>
          <p>
            <strong>Division:</strong> {data.Division}
          </p>
          <p>
            <strong>Region:</strong> {data.Region}
          </p>
          <p>
            <strong>Country:</strong> India
          </p>
        </div>
      )}
    </div>
  );
}
